module.exports = __webpack_public_path__ + "img/screenshot-4.6a0dbdd4.webp";